'use strict';

module.exports = {
    excel: 'excel',
    json: 'json',
};
